export default "__VITE_ASSET__3c40eeb2__"